import { render, staticRenderFns } from "./sale_giftCard.vue?vue&type=template&id=21d5fa74&scoped=true&"
import script from "./sale_giftCard.vue?vue&type=script&lang=js&"
export * from "./sale_giftCard.vue?vue&type=script&lang=js&"
import style0 from "./sale_giftCard.vue?vue&type=style&index=0&id=21d5fa74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5fa74",
  null
  
)

export default component.exports